module.exports = __webpack_public_path__ + "static/q8-37a0e215605e0b67c1f2d6ec85a1c595.svg";